export const cryptoWords = [
	'12422428114843875',
	'4580834472737839',
	'15275549063839753',
	'2014460075568872',
	'2282857669132987',
	'49130864665309784',
	'4415369034407662',
	'3329301880885401',
	'88147341816910937',
	'4506905469970566',
];
